import { LockOutlined, SafetyOutlined, UserOutlined } from '@ant-design/icons';
import { Button, Col, Form, Input, Layout, Row, Tabs, Statistic } from 'antd';
import { debounce } from 'lodash';
import BaseComponent from 'base/BaseComponent';
import { enhance } from 'base/BaseEnhance';
import Constants from 'constants/Constants';
import React from 'react';
import { connect } from 'react-redux';
import { logout } from 'redux/actions/';
import SessionService from 'service/SessionService';
import { mobileRule } from 'util/src/PatternUtil';
import Register from 'view/register/Register';
import './Login.less';
import { encrypt } from './jsencryptUtil';

const { Footer, Content } = Layout;
const { TabPane } = Tabs;

const { Countdown } = Statistic;

const captchaImagePath = Constants.BACK_HOST_URI_PREFIX + '/getCaptchaImage';

/**
 * 登录界面
 */
class Login extends BaseComponent {
  constructor(props) {
    super(props, false);

    this.state = {
      captchaImagePath: captchaImagePath,
      needCaptcha: this.getNeedCaptcha(),
      isSend: false,
      verifyCodeTitle: '点击获取短信验证码',
      pubKey: null,
      showAdditionalInput: false
    };

    // 清空state数据、防止其他用户登录时保留之前用户state信息
    this.props.logout();
    this.sendVerifyCodeAndLoginName = debounce(this.sendVerifyCodeAndLoginName, 500);
    this.sendVerifyCode = debounce(this.sendVerifyCode, 500);
  }

  componentDidMount() {
    this.initializePage();
  }

  handleShowAdditionalInput(event) {
    const loginNameValue = event.target.value.toLowerCase();
    if (loginNameValue === 'sysadmin') {
      this.setState({ showAdditionalInput: true });
    } else {
      this.setState({ showAdditionalInput: false });
    }
  }

  initializePage = async() => {
    await this.getPubKey();
  };

  getNeedCaptcha = () => {
    return SessionService.loginErrorCnt >= Constants.MAX_LOGIN_ERROR_CNT_WITHOUT_CAPTCHA;
  }

  getPubKey = () => {
    this.sendPostRequest('getRsaPubKey', null, (result) => {
      this.setState(
        {
          pubKey: result
        }
      );
    });
  };

  handleSubmit = async (values) => {
    if (this.state.showAdditionalInput) {
      // 等保整改，混合登录（账号+密码+手机号+验证码）仅针对sysadmin用户
      if (this.state.pubKey) {
        // RSA加密
        // 加密账号
        const encryptedLoginName = encrypt(values.loginName, this.state.pubKey);
        // 加密密码
        const encryptedPassword = encrypt(values.password, this.state.pubKey);
        this.sendPostRequest('login', {
          ...values,
          loginName: encryptedLoginName,
          password: encryptedPassword,
          systemTypeList: [0, 1, 3]
        }, (result) => {
          this.sendPostRequest('/plat-delivery/login/smsLogin', { loginName: values.loginName, mobile: values.mobile, verifyCode: values.verifyCode }, (result) => {
            this.onLoginSuccess(result);
          });
        });
      } else {
        this.sendPostRequest('login', { ...values, systemTypeList: [0, 1, 3] }, (result) => {
          this.sendPostRequest('/plat-delivery/login/smsLogin', { loginName: values.loginName, mobile: values.mobile, verifyCode: values.verifyCode }, (result) => {
            this.onLoginSuccess(result);
          });
        });
      }
    } else {
      // 原有登录（账号密码）
      if (this.state.pubKey) {
        // 加密账号
        const encryptedLoginName = encrypt(values.loginName, this.state.pubKey);
        // 加密密码
        const encryptedPassword = encrypt(values.password, this.state.pubKey);
        this.sendPostRequest('login', {
          ...values,
          loginName: encryptedLoginName,
          password: encryptedPassword,
          systemTypeList: [0, 1, 3]
        }, (result) => {
          this.onLoginSuccess(result);
        });
      } else {
        this.sendPostRequest('login', { ...values, systemTypeList: [0, 1, 3] }, (result) => {
          this.onLoginSuccess(result);
        });
      }
    }
  }

  smsLogin = values => {
    this.sendPostRequest('/plat-delivery/login/smsLogin', { ...values }, (result) => {
      this.onLoginSuccess(result);
    });
  }

  onLoginSuccess = (result) => {
    // 登录成功后，将错误计数改为0
    SessionService.loginErrorCnt = 0;
    SessionService.userName = result.userName;
    SessionService.localUserName = result.userName;
    SessionService.proxyUserName = result.proxyUserName;
    SessionService.systemType = result.systemType;
    // PrivilegeService.disabledPrivilegeInfo = result.disabledFrontPrivilegePathList;
    sessionStorage.setItem('disablePrivilegePaths', JSON.stringify(result.disabledFrontPrivilegePathList || []));
    this.showNotification('欢迎' + result.userName, 'success');

    if (result.resetPassword != null) {
      this.props.history.push('/', { resetPassword: '1' });
    } else {
      this.props.history.push('/');
    }
  }

  onError(errorMessage, errorCode) {
    if (errorCode === Constants.ERROR_CODE_NEED_CAPTCHA) {
      SessionService.loginErrorCnt = Constants.MAX_LOGIN_ERROR_CNT_WITHOUT_CAPTCHA;
    } else if (errorCode !== '0') {
      SessionService.loginErrorCnt++;
    }
    this.setState({
      needCaptcha: this.getNeedCaptcha()
    });
    super.onError(errorMessage);
    this.changeCaptchaImage();
  }

  changeCaptchaImage = () => {
    this.setState(
      {
        captchaImagePath: captchaImagePath + '?cnt=' + Math.random()
      }
    );
  }

  // 等保整改，混合登录（账号+密码+手机号+验证码）仅针对sysadmin用户
  sendVerifyCodeAndLoginName = () => {
    if (!this.sendMobile) {
      this.showMessage('请输入手机号');
      return;
    }
    this.setState({
      isSend: true
    });
    this.sendPostRequest('/plat-delivery/login/sendLoginVerifyCode', { mobile: this.sendMobile, loginName: 'sysadmin' }, () => {
      this.setState({
        verifyCodeTitle: this.getCountdown()
      });
    }, (error) => {
      this.showMessage(error);
      this.setState({
        isSend: false
      });
    });
  }

  // 发送验证码
  sendVerifyCode = () => {
    if (!this.sendMobile) {
      this.showMessage('请输入手机号');
      return;
    }
    this.setState({
      isSend: true
    });
    this.sendPostRequest('/plat-delivery/login/sendLoginVerifyCode', { mobile: this.sendMobile }, () => {
      this.setState({
        verifyCodeTitle: this.getCountdown()
      });
    }, (error) => {
      this.showMessage(error);
      this.setState({
        isSend: false
      });
    });
  }

  getCountdown = () => {
    return (<React.Fragment>重新获取(<Countdown value={Date.now() + 1000 * 60} suffix='s' format="ss" onFinish={() => { this.setState({ isSend: false, verifyCodeTitle: '点击获取短信验证码' }); }} />)</React.Fragment>);
  }

  render() {
    return (
      <Layout className="fh-layout-wrapper">
        <Content className="fh-content-wrapper">
          <div className="fh-content-inner-wrapper">
            <div className="fh-logo-container"></div>
            <Tabs defaultActiveKey="1" className="customize-tabs-bar">
              <TabPane tab="账号登录" key="1">
                <Form onFinish={this.handleSubmit} style={{ marginTop: '10px' }}>
                  <Form.Item name="loginName" rules={[{ required: true, message: '用户名不能为空' }]}>
                    <Input addonBefore={<UserOutlined />}
                      placeholder="请输入用户名"
                      onBlur={(event) => this.handleShowAdditionalInput(event)}
                    />
                  </Form.Item>
                  <Form.Item name="password" rules={[{ required: true, message: '密码不能为空' }]} className="fh-password-input">
                    <Input.Password addonBefore={<LockOutlined />} type="password" placeholder="请输入密码" />
                  </Form.Item>
                  {this.state.showAdditionalInput ? (
                    <Input.Group>
                      <Form.Item label='手机' name='mobile' key='mobile' rules={[{ required: true, message: '请输入手机号' }, mobileRule()]}>
                        <Input type="text" onChange={e => { this.sendMobile = e.target.value; }} />
                      </Form.Item>
                      <Form.Item label="验证码">
                        <Row gutter={8}>
                          <Col span={10}>
                            <Form.Item
                              name="verifyCode"
                              key='verifyCode'
                              noStyle
                              rules={[{ required: true, message: '请输入获取的验证码' }]}
                            >
                              <Input />
                            </Form.Item>
                          </Col>
                          <Col span={14}>
                            <Button onClick={this.sendVerifyCodeAndLoginName} disabled={this.state.isSend}>{this.state.verifyCodeTitle}</Button>
                          </Col>
                        </Row>
                      </Form.Item>
                    </Input.Group>) : ''
                  }
                  {
                    this.state.needCaptcha ? (
                      <Input.Group>
                        <Row gutter={8} type="flex" justify="space-around">
                          <Col span={8}>
                            <Form.Item name="captcha" rules={[{ required: true, message: '请输入验证码' }]} style={{ height: 40 }} className="fh-captche-input">
                              <Input prefix={<SafetyOutlined />} placeholder="验证码" />
                            </Form.Item>
                          </Col>
                          <Col span={10}>
                            <img alt='验证码' src={this.state.captchaImagePath} onClick={this.changeCaptchaImage} height="40" style={{ cursor: 'pointer', width: 137 }} />
                          </Col>
                          <Col span={6}>
                            <Button onClick={this.changeCaptchaImage} className="fh-captche-button">看不清</Button>
                          </Col>
                        </Row>
                      </Input.Group>) : ''
                  }
                  <Form.Item>
                    <Button type="primary" htmlType="submit" block
                      className="login-form-button fh-login-button">登录</Button>
                  </Form.Item>
                </Form>
              </TabPane>
              <TabPane tab="短信登录" key="2">
                <Form onFinish={this.smsLogin} style={{ marginTop: '10px' }}>
                  <Form.Item label='手机' name='mobile' key='mobile' rules={[{ required: true, message: '请输入手机号' }, mobileRule()]}>
                    <Input type="text" onChange={e => { this.sendMobile = e.target.value; }} />
                  </Form.Item>
                  <Form.Item label="验证码">
                    <Row gutter={8}>
                      <Col span={10}>
                        <Form.Item
                          name="verifyCode"
                          key='verifyCode'
                          noStyle
                          rules={[{ required: true, message: '请输入获取的验证码' }]}
                        >
                          <Input />
                        </Form.Item>
                      </Col>
                      <Col span={14}>
                        <Button onClick={this.sendVerifyCode} disabled={this.state.isSend}>{this.state.verifyCodeTitle}</Button>
                      </Col>
                    </Row>
                  </Form.Item>
                  <Form.Item>
                    <Button type="primary" htmlType="submit" block
                      className="login-form-button fh-login-button">登录</Button>
                  </Form.Item>
                </Form>
              </TabPane>
            </Tabs>
            <Register />
          </div>
        </Content>
        <Footer className="fh-footer-wrapper">© 峰禾科技 版权所有</Footer>
      </Layout>
    );
  }
}

export default connect(null, { logout })(enhance(Login));
